var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Mastercard24 = function Mastercard24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.59 19.545v.04h.038a.04.04 0 0 0 .02-.005.018.018 0 0 0 .008-.015.017.017 0 0 0-.007-.015.036.036 0 0 0-.02-.005h-.038zm.039-.029a.07.07 0 0 1 .044.013c.011.009.016.02.016.036a.04.04 0 0 1-.012.03.06.06 0 0 1-.036.016l.05.057h-.04l-.045-.057h-.015v.057h-.032v-.152h.07zm-.01.204a.13.13 0 0 0 .116-.078.13.13 0 0 0-.027-.14.126.126 0 0 0-.09-.037.127.127 0 0 0-.09.037.123.123 0 0 0-.027.041.123.123 0 0 0-.01.05c0 .017.004.034.01.05a.156.156 0 0 0 .027.04.129.129 0 0 0 .09.037zm0-.29a.164.164 0 0 1 .153.1.156.156 0 0 1 0 .127.17.17 0 0 1-.088.086.167.167 0 0 1-.232-.15.16.16 0 0 1 .101-.15.167.167 0 0 1 .066-.013zm-15.315-.583c0-.289.19-.526.498-.526.295 0 .495.227.495.526 0 .298-.2.525-.495.525-.309 0-.498-.237-.498-.525zm1.329 0v-.82h-.357v.198a.622.622 0 0 0-.518-.24c-.46 0-.822.36-.822.862 0 .501.361.862.822.862a.622.622 0 0 0 .518-.24v.198h.357v-.82zm12.061 0c0-.289.19-.526.498-.526.296 0 .495.227.495.526 0 .298-.199.525-.495.525-.309 0-.498-.237-.498-.525zm1.33 0v-1.48h-.358v.858a.622.622 0 0 0-.518-.24c-.46 0-.821.36-.821.862 0 .501.36.862.82.862a.622.622 0 0 0 .52-.24v.198h.357v-.82zm-8.96-.543c.23 0 .377.145.415.399h-.852c.038-.237.182-.398.436-.398zm.006-.319c-.48 0-.817.35-.817.862 0 .522.35.862.841.862a.998.998 0 0 0 .673-.23l-.175-.265a.785.785 0 0 1-.477.172c-.23 0-.44-.107-.491-.402h1.219c.004-.044.007-.09.007-.137-.003-.512-.32-.862-.78-.862zm4.31.862c0-.289.19-.526.498-.526.296 0 .495.227.495.526 0 .298-.2.525-.495.525-.309 0-.498-.237-.498-.525zm1.33 0v-.82h-.358v.198a.623.623 0 0 0-.518-.24c-.46 0-.821.36-.821.862 0 .501.36.862.82.862a.623.623 0 0 0 .52-.24v.198h.356v-.82zm-3.346 0c0 .498.347.862.876.862a.86.86 0 0 0 .59-.196l-.17-.289a.722.722 0 0 1-.43.148c-.285-.003-.495-.21-.495-.525 0-.316.21-.522.495-.526.155 0 .295.052.43.148l.17-.288a.86.86 0 0 0-.59-.196c-.529 0-.876.364-.876.862zm4.602-.862a.484.484 0 0 0-.432.24v-.199h-.354v1.641h.357v-.92c0-.271.117-.422.35-.422a.58.58 0 0 1 .224.041l.11-.336a.762.762 0 0 0-.255-.045zm-9.568.172c-.171-.113-.408-.172-.67-.172-.415 0-.683.2-.683.525 0 .268.2.433.567.485l.168.023c.196.028.289.08.289.172 0 .127-.131.2-.375.2a.875.875 0 0 1-.546-.172l-.168.278c.196.144.443.213.71.213.475 0 .75-.224.75-.536 0-.288-.217-.44-.574-.49l-.168-.025c-.155-.02-.278-.051-.278-.161 0-.12.116-.192.312-.192.21 0 .412.079.512.14l.154-.288zm4.606-.172a.483.483 0 0 0-.433.24v-.199h-.354v1.641h.357v-.92c0-.271.117-.422.35-.422.073 0 .149.01.224.041l.11-.336a.761.761 0 0 0-.254-.045zm-3.046.041h-.584v-.498h-.36v.498H9.68v.326h.333v.75c0 .38.148.607.57.607a.838.838 0 0 0 .447-.127l-.103-.306a.66.66 0 0 1-.316.093c-.179 0-.237-.11-.237-.275v-.742h.584v-.326zM5.62 19.667v-1.03c0-.387-.247-.648-.646-.652a.636.636 0 0 0-.577.292.603.603 0 0 0-.542-.292.543.543 0 0 0-.481.244v-.203h-.358v1.641h.36v-.91c0-.284.159-.436.403-.436.237 0 .357.155.357.433v.913h.36v-.91c0-.284.165-.436.403-.436.243 0 .36.155.36.433v.913h.36z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.811 14.21v-.24h-.062l-.073.165-.071-.165h-.063v.24h.044v-.18l.068.155h.046l.067-.156v.181h.044zm-.396 0v-.199h.08v-.04h-.204v.04h.08v.199h.044z",
    fill: "#F79410"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.704 15.241H9.296V5.522h5.41v9.72z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.642 10.38a6.17 6.17 0 0 1 2.36-4.859 6.181 6.181 0 1 0 0 9.719 6.17 6.17 0 0 1-2.36-4.86z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 10.38a6.181 6.181 0 0 1-10.003 4.86 6.169 6.169 0 0 0 2.361-4.86 6.169 6.169 0 0 0-2.361-4.859A6.181 6.181 0 0 1 22 10.381z",
    fill: "#F79E1B"
  }));
};

Mastercard24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Mastercard32 = function Mastercard32(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("rect", {
    x: ".5",
    y: ".5",
    width: "31",
    height: "23",
    rx: "3.5",
    fill: "#fff",
    stroke: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.947 18.884a6.945 6.945 0 0 0 6.948-6.942A6.945 6.945 0 0 0 11.947 5 6.945 6.945 0 0 0 5 11.942a6.945 6.945 0 0 0 6.947 6.942z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.053 19A6.945 6.945 0 0 0 27 12.058a6.945 6.945 0 0 0-6.947-6.942 6.945 6.945 0 0 0-6.948 6.942A6.945 6.945 0 0 0 20.053 19z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.102 6.348a6.93 6.93 0 0 1 2.793 5.564 6.932 6.932 0 0 1-2.996 5.71 6.93 6.93 0 0 1-2.793-5.564 6.932 6.932 0 0 1 2.996-5.71z",
    fill: "#FF5F00"
  }));
};

Mastercard32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Mastercard24,
  '32': Mastercard32
};
export var Mastercard = function Mastercard(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Mastercard' icon. Please use one of the available sizes: '24', '32'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};